// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for BalanceTarget.
 * @see #/components/schemas/BalanceTarget - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface BalanceTarget {
    /**
     * Practitioner unique id.
     * @dataFormat uuid
     */
    last_changed_by: string | null;
    /**
     * Timestamp when this entity was last modified.
     * @dataFormat date-time
     */
    last_changed_at: string;
    /**
     * The actual value of the balance target.
     * @dataFormat double
     */
    value: number;
    /**
     * The date when value was created.
     * @dataFormat date-time
     */
    date: string;
    /**
     * The unit of the value.
     *
     */
    unit: string;
    /**
     * The identifier of related Patient.
     * @dataFormat uuid
     */
    patient_id: string;
    /**
     * BalanceTarget unique id.
     * @dataFormat uuid
     */
    id: string;
    /**
     * The identifier of the related Practitioner.
     * @dataFormat uuid
     */
    author_id: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for BalanceTarget
 */
export namespace BalanceTarget {
    /**
     * BalanceTarget Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Practitioner unique id.
         * @dataFormat uuid
         */
        lastChangedBy: string | null;
        /**
         * Timestamp when this entity was last modified.
         * @dataFormat date-time
         */
        @TransformDate() lastChangedAt: Date;
        /**
         * The actual value of the balance target.
         * @dataFormat double
         */
        value: number;
        /**
         * The date when value was created.
         * @dataFormat date-time
         */
        @TransformDate() date: Date;
        /**
         * The unit of the value.
         * @type string (`dataFormat` is missing)
         */
        unit: string;
        /**
         * The identifier of related Patient.
         * @dataFormat uuid
         */
        patientId: string;
        /**
         * BalanceTarget unique id.
         * @dataFormat uuid
         */
        id: string;
        /**
         * The identifier of the related Practitioner.
         * @dataFormat uuid
         */
        authorId: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * BalanceTarget DTO
     * Transforms BalanceTarget model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend BalanceTarget model */
        static toModel(obj: BalanceTarget): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend BalanceTarget model */
        static toApi(obj: Model): BalanceTarget {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as BalanceTarget;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
